<template>
  <div class="bot-body">
    <a class="bot" :href="$store.state.botUrl" alt="智能客服" target="_blank">
      <p>智能客服</p>
    </a>
  </div>
</template>

<script>
export default {

}
</script>

<style>
</style>
